import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="Logo"
      src="/static/garri-logo-light.jpg"
      {...props}
    />
  );
};

export default Logo;
